/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistAliasCreateSourceIds } from './ArtistAliasCreateSourceIds';
import {
    ArtistAliasCreateSourceIdsFromJSON,
    ArtistAliasCreateSourceIdsFromJSONTyped,
    ArtistAliasCreateSourceIdsToJSON,
} from './ArtistAliasCreateSourceIds';

/**
 * 
 * @export
 * @interface ArtistAliasUpdate
 */
export interface ArtistAliasUpdate {
    /**
     * 
     * @type {string}
     * @memberof ArtistAliasUpdate
     */
    stageName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAliasUpdate
     */
    manualStageName?: boolean;
    /**
     * 
     * @type {ArtistAliasCreateSourceIds}
     * @memberof ArtistAliasUpdate
     */
    sourceIds?: ArtistAliasCreateSourceIds;
}

/**
 * Check if a given object implements the ArtistAliasUpdate interface.
 */
export function instanceOfArtistAliasUpdate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ArtistAliasUpdateFromJSON(json: any): ArtistAliasUpdate {
    return ArtistAliasUpdateFromJSONTyped(json, false);
}

export function ArtistAliasUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistAliasUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': !exists(json, 'stageName') ? undefined : json['stageName'],
        'manualStageName': !exists(json, 'manualStageName') ? undefined : json['manualStageName'],
        'sourceIds': !exists(json, 'source_ids') ? undefined : ArtistAliasCreateSourceIdsFromJSON(json['source_ids']),
    };
}

export function ArtistAliasUpdateToJSON(value?: ArtistAliasUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'manualStageName': value.manualStageName,
        'source_ids': ArtistAliasCreateSourceIdsToJSON(value.sourceIds),
    };
}

